import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=0528d9f8&scoped=true&"
import script from "./FilterTags.vue?vue&type=script&lang=ts&"
export * from "./FilterTags.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTags.vue?vue&type=style&index=0&id=0528d9f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528d9f8",
  null
  
)

export default component.exports